export default __webpack_public_path__ + "static/media/Screen3.e7807e71.png";